/**
 * The two shapes a failed API call arrives in. The app's Axios interceptor rejects an HTTP failure
 * with the response itself, so the status and the Calm error code sit at the top level and under
 * `data.error`. A raw Axios error still nests the response. A network error has neither.
 */
type FailedRequest = {
	status?: number;
	response?: { status?: number; data?: { error?: { code?: string } } };
	data?: { error?: { code?: string } };
	calmCode?: string;
	code?: string;
};

const asFailedRequest = (error: unknown): FailedRequest | null =>
	typeof error === 'object' && error !== null ? (error as FailedRequest) : null;

export const getResponseStatus = (error: unknown): number | null => {
	const failed = asFailedRequest(error);
	return failed?.status ?? failed?.response?.status ?? null;
};

/** The Calm wire code (`campaign_code_expired`, `already_subscribed`, ...) if the response carried one. */
export const getCalmErrorCode = (error: unknown): string | null => {
	const failed = asFailedRequest(error);
	return (
		failed?.calmCode ??
		failed?.data?.error?.code ??
		failed?.response?.data?.error?.code ??
		failed?.code ??
		null
	);
};
